import React, { useEffect, useRef } from "react";
import styles from "./StatsBar.module.scss";

const stats = [
    { value: "5 Million+", label: "Games played" },
    { value: "No subscription", label: "Buy once, play forever" },
    { value: "1-8 players", label: "Any screen, any browser" },
];

const TrustpilotWidget = () => {
    const widgetRef = useRef(null);

    useEffect(() => {
        if (window.Trustpilot && widgetRef.current) {
            window.Trustpilot.loadFromElement(widgetRef.current, true);
        }
    }, []);

    return (
        <div
            ref={widgetRef}
            className="trustpilot-widget"
            data-locale="en-US"
            data-template-id="54197383fd9dceac42a68694"
            data-businessunit-id="653f8fcfe9710b8d04037792"
            data-style-width="100%"
            data-style-size="XS"
            data-token="8f7e2183-779e-4074-9175-4d17d7cb5cd7"
            data-text-color="light"
            data-border-type="shadow"
            data-headline="word"
            data-background="glass"
            data-external-elements-color="dark"
        >
            <a href="https://www.trustpilot.com/review/game.city" target="_blank" rel="noopener">
                Trustpilot
            </a>
        </div>
    );
};

const StatsBar = () => {
    return (
        <section className={styles.statsBar}>
            <div className={styles.statsGrid}>
                {stats.map((stat, i) => (
                    <div key={`stat-${i}`} className={styles.statItem}>
                        <span className={styles.statValue}>{stat.value}</span>
                        <span className={styles.statLabel}>{stat.label}</span>
                    </div>
                ))}
                <div className={styles.statItem}>
                    <TrustpilotWidget />
                </div>
            </div>
        </section>
    );
};

export default StatsBar;
